import { computed, observable } from "mobx";
import AccountingTemplateCode from "./accountingTemplateCode";
import type { IEnum } from "./enum";
import Optionable from "utils/optionable";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class AccountingTemplateResponse {
  id!: string;

  @observable
  code!: AccountingTemplateCode;

  @observable
  message!: string;
}

@Optionable((accountingTemplate: AccountingTemplateEnums) => ({
  id: accountingTemplate.id,
  label: `${accountingTemplate.code} - ${accountingTemplate.message}`,
}))
export default class AccountingTemplateEnums extends AccountingTemplateResponse implements IEnum {
  @computed
  get name() {
    return this.message;
  }
}
